const getFacilityAddress = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Address'] && facility['Company Address'].ID) {
    if (facility['Company Address'].Suite) {
      return `${facility['Company Address'].Street} SUITE. ${facility['Company Address'].Suite}, ${facility['Company Address'].City}, ${facility['Company Address'].State} ${facility['Company Address']['Zip Code']}`.toUpperCase();
    }
    return `${facility['Company Address'].Street}, ${facility['Company Address'].City}, ${facility['Company Address'].State} ${facility['Company Address']['Zip Code']}`.toUpperCase();
  }
  return null;
};

export default getFacilityAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityAddress.js